export const environment = {
  /**
   * マップの切り替え.
   *
   * - none : マップ使用しない
   * - osm : OpenStreetMap
   * - google : Google Map
   *    `index.html` に `<script src="https://maps.googleapis.com/maps/api/js?key=${GoogleMapApikey}" async defer></script>` を指定してください。
   */
  map: 'google',
  servicerApiUrl: 'https://nissan-mslab-mw.com/vehicle',
  serverlessApiUrl: 'https://6kyk3qgd9g.execute-api.ap-northeast-1.amazonaws.com/vehicle',
  servicerApiUrls: [
    'http://localhost:8082/vehicle',
    'http://localhost:8081'
  ],
  /**
   * タイトル.
   *
   * - 浪江/NATC(浪江同等) : Namie Mobility Service
   * - シャドーFMS/横浜 : Nissan Mobility Service
   */
  title: 'Mobility Service',
  /**
   * [システム]ダッシュボードAPIを取得する間隔（単位：ms）.
   * FMS/CMS の一覧を表示する間隔に影響する.
   *
   * - 浪江/NATC(浪江同等) : 10000
   * - シャドーFMS/横浜 : 1000
   */
  systemDashboardInterval: 10000,
  /**
   * シミュレート結果を確認する間隔（単位：ms）.
   */
  simulateResultInterval: 10000,
  /**
   * [システム] [休憩計画]ダッシュボードAPIを取得する間隔（単位：ms）.
   */
  systemRestPlanDashboardInterval: 10000,
  /**
   * [休憩計画] 需要の評価の色を変えるための値.
   */
  restPlanDemandCount: 10,

  /** 間隔 */
  intervals: {

    /** トップ画面 V3リクエスト実行間隔（sec） */
    top: 1,

    /** FMS画面 V3リクエスト実行間隔（sec） */
    fms: 10,

    /** 音声機能情報取得 (sec) */
    peer: 1
  },

  /**
   * HOME画面の環境変数
   */
  home: {

    /** 言語 */
    language: 'ja',

    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 5,

    }
  },
  /**
   * エリアインデックス.
   * - 横浜 : 1
   */
  areaIndex: 0,
  /** エリアリスト. */
  red5ProliveStream : {
    red5ProUsername: '',
    red5ProPassword: '',
    red5ProHost: '',
    red5ProPort: 443,
    red5ProApp: 'live',
    red5ProMediaElementId: ''
  },
  peerServerInfo : {
    peerHost: '',
    peerPort: 9001,
    peerpath: '/'
  },
  areas: [
    {
      name: '横浜',
      areaId: 3,
      hubAreaId: 4,
      spokeAreaId: 3,
      lat: 35.450939000,
      lon: 139.638361000,
      zoom: 15,
      userPattern: '^(U|N)(0[0-9][0-9]|100)$',
      fmsVehicles:[
        {
          category: {
            title: 'サービス車両',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        }
      ],
      basePolylines: []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts